import {nameForAnalytics} from '@rdcomponents/navigation/navigation-type';
import {FC, useCallback} from 'react';

import {appRoute} from '../../../../app-route';
import {LocalPack} from '../../../../page/main/local-pack/local-pack';
import {LocalPackActivation} from '../../../../page/main/local-pack/local-pack-activation/local-pack-activation';
import {LocalPackCreateRulePage} from '../../../../page/main/local-pack/local-pack-create-rule-page/local-pack-create-rule-page';
import {LocalPackEditRulePage} from '../../../../page/main/local-pack/local-pack-edit-page/local-pack-edit-rule-page';
import {LocalPackLeaderBoardPage} from '../../../../page/main/local-pack/local-pack-leaderboard-page/local-pack-leader-board-page';
import {LocalPackResultPage} from '../../../../page/main/local-pack/local-pack-result-page/local-pack-result-page';
import {LocalPackRulesPage} from '../../../../page/main/local-pack/local-pack-rules-page/local-pack-rules-page';
import {LocalPackSearchPhrasesStatisticsPage} from '../../../../page/main/local-pack/local-pack-search-phrases-statistics-page/local-pack-search-phrases-statistics-page';
import {useLicenses} from '../../../../provider/license/license-hook';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {useUser} from '../../../../provider/user/user-hook';
import {FeaturesEnum} from '../../../../service/user/user-type';
import {getFeatureOrLandingPage, getMenuItemNameForAnalytics} from '../../../navigation/navigation-helper';
import {NavigationItemConfigType} from '../routing-type';

export function useLocalPackNavigation(isLocalPackAvailable: boolean): Array<NavigationItemConfigType> {
    const {user} = useUser();
    const {licenses} = useLicenses();
    const {getLocalizedString} = useLocale();

    const getLocalPackFeatureOrLandingPage = useCallback(
        (pageComponent: FC<Record<string, unknown>>) => {
            return getFeatureOrLandingPage({
                license: licenses[FeaturesEnum.localPack],
                activationComponent: LocalPackActivation,
                pageComponent,
            });
        },
        [licenses]
    );

    return [
        {
            isAvailable: isLocalPackAvailable,
            isActivated: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
            path: appRoute.competitorsLocalPack.path,
            label: getLocalizedString('CATEGORY_NAME__LOCAL_PACK'),
            [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__LOCAL_PACK'),
            exact: true,
            component: getLocalPackFeatureOrLandingPage(LocalPack),
        },
        {
            isOnlyRoute: true,
            isAvailable: isLocalPackAvailable,
            isActivated: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
            path: appRoute.competitorsLocalPackResult.path,
            exact: true,
            component: getLocalPackFeatureOrLandingPage(LocalPackResultPage),
        },
        {
            isOnlyRoute: true,
            isAvailable: isLocalPackAvailable && user?.isStaff,
            isActivated: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
            path: appRoute.competitorsLocalPackRules.path,
            exact: true,
            component: getLocalPackFeatureOrLandingPage(LocalPackRulesPage),
        },
        {
            isOnlyRoute: true,
            isAvailable: isLocalPackAvailable && user?.isStaff,
            isActivated: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
            path: appRoute.competitorsLocalPackRuleCreate.path,
            exact: true,
            component: getLocalPackFeatureOrLandingPage(LocalPackCreateRulePage),
        },
        {
            isOnlyRoute: true,
            isAvailable: isLocalPackAvailable && user?.isStaff,
            isActivated: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
            path: appRoute.competitorsLocalPackRuleEdit.path,
            exact: true,
            component: getLocalPackFeatureOrLandingPage(LocalPackEditRulePage),
        },
        {
            isOnlyRoute: true,
            isAvailable: isLocalPackAvailable,
            isActivated: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
            path: appRoute.competitorsLocalPackLeaderBoard.path,
            exact: true,
            component: getLocalPackFeatureOrLandingPage(LocalPackLeaderBoardPage),
        },
        {
            isOnlyRoute: true,
            isAvailable: isLocalPackAvailable,
            isActivated: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
            path: appRoute.competitorsLocalPackSearchPhrasesStatistics.path,
            exact: true,
            component: getLocalPackFeatureOrLandingPage(LocalPackSearchPhrasesStatisticsPage),
        },
    ];
}
